/*jshint unused:false*/
/*global fetch */
/*global console */

//object fit fix for ie11
var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);


if(ie) {
  var imgContainer = document.querySelectorAll(".img-container");

  for(var i=0; i<imgContainer.length; i++){
    var imgCtr = imgContainer[i];
    var imgUrl = imgCtr.getElementsByTagName("img")[0].src;
    if (imgUrl) {
      imgCtr.setAttribute("style", "background-image:url('" + imgUrl + "')");
      imgCtr.classList.add("custom-object-fit");
    }
  }
}

function writeCookie(key, value, days) {
  let date = new Date();
  days = days || 7;
  date.setTime(+ date + (days * 86400000)); //24 * 60 * 60 * 1000
  window.document.cookie = key + "=" + value + "; expires=" + date.toGMTString() + "; path=/";
  return value;
}

// Back to top button
const scrollToTopButton = document.getElementById('back_to_top');
let smoothScrollCapture = (x) => {
  event.preventDefault();
  let id = x.currentTarget.target.getAttribute('href').split("#")[1]
  let el = document.getElementById(id);
  var x = el.getBoundingClientRect().left;
  var y = el.getBoundingClientRect().top;
  smoothScrollFunc(x, y)
}
let smoothScrollFunc = (x, y) => {
  event.preventDefault();
  window.scrollTo({
    top: y,
    left: x,
    behavior: 'smooth'
  });
}
window.addEventListener('DOMContentLoaded', () => {
  scrollToTopButton.addEventListener('click', () => {
    smoothScrollFunc(0, 0);
  })
})

document.querySelectorAll('select').forEach(v => {
  v.addEventListener('change', (e) => {
    v.blur();
  })
})

window.addEventListener('scroll', () => {
  let pageHeight = document.body.scrollHeight;
  let currentHeight = window.scrollY;
  (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
})
// End back to top button

// Price toggles
function priceToggles() {
  let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
  let priceContainers = [].slice.call(document.querySelectorAll('.deal-price-toggle'));
  let priceSwitchForm = [].slice.call(document.querySelectorAll('.price-toggle'));
  let toggleOn = [].slice.call(document.querySelectorAll('.price-toggle .toggles-on'));
  let toggleOff = [].slice.call(document.querySelectorAll('.price-toggle .toggles-off'));
  // let priceSwitchForm = document.getElementById('price-switch');
  let selected;
  allSwitches.forEach((value) => {
    value.addEventListener('change', (val) => {
      (val.composedPath()[0].classList.contains('toggle-personal')) ? selected = 0 : selected = 1;
      if(val.composedPath()[0].classList.contains('price-toggle-checkbox')){
        (val.target.checked === true) ? selected = 1 : selected = 0;
      }

      (selected === 0) ? toggleOn.forEach(value => { value.classList.add('active') }) : toggleOn.forEach(value => { value.classList.remove('active') });
      (selected === 1) ? toggleOff.forEach(value => { value.classList.add('active') }) : toggleOff.forEach(value => { value.classList.remove('active') });
      toggleSwitches();
      togglePrices();
      updatePrice();
      updateButton();
      updateHeader();
      // val.target.scrollIntoView();
    })
  })
  let toggleSwitches = () => {
    allSwitches.forEach((v) => {
      (selected === 0) ? v.querySelectorAll('.toggle-personal').forEach((v) => { v.checked = true }) : v.querySelectorAll('.toggle-business').forEach((v) => { v.checked = true });
      (selected === 0) ? document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = false }) : document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = true });
    })
    document.querySelector("#switch-price-type").value = (selected === 0) ? 'Personal' : 'Business';
    document.querySelectorAll(".price-title-type").forEach((v) => {
      v.innerHTML = (selected === 0) ? 'Personal' : 'Business';
    })
  }
  let togglePrices = () => {
    priceContainers.forEach((v) => {
      (selected === 0) ? v.querySelectorAll('.price-personal').forEach(value => { value.classList.add('active') }) : v.querySelectorAll('.price-personal').forEach((value => { value.classList.remove('active') }));
      (selected === 1) ? v.querySelectorAll('.price-business').forEach(value => { value.classList.add('active') }) : v.querySelectorAll('.price-business').forEach((value => { value.classList.remove('active') }));
    })
  }
  let updatePrice = () => {
    let url = priceSwitchForm[0].getAttribute('action');
    let formData = new FormData(priceSwitchForm[0]);
    fetch(url, {
      method: 'POST',
      processData: false,
      contentType: false,
      body: formData,
      headers: {
        'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
        'X-Requested-With': 'XMLHttpRequest'
      },
    }).then(
      function(response) {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        response.json().then(function(data) {
          document.querySelector("#price-switch [name=_token]").value = data.token;
        });
      }
    ).catch(function(err) {
      console.log('Fetch Error :-S', err);
    });
  }
  let updateButton = () => {
    let manufacturerButton = document.querySelector('.view-all > a');
    if (manufacturerButton) {
      (selected === 0) ? manufacturerButton.setAttribute('href', '/car-leasing/manufacturers') : manufacturerButton.setAttribute('href', '/van-leasing/manufacturers');
    }
  }
  let updateHeader = () => {
    let manufacturerHeader = document.querySelector('.manufacturer-strip-intro > h2 > span');
    if (manufacturerHeader) {
      (selected === 0) ? manufacturerHeader.innerHTML = 'Car' : manufacturerHeader.innerHTML = 'Van';
    }
  }
}
priceToggles();
// End price Toggles


//Nav Toggle
function toggleNav(el) {
    var element = el;
    var menu = document.getElementById("site-menu");
    var header = document.querySelectorAll(".site-header")[0];
    menu.classList.toggle("active");
    header.classList.toggle("active");

    if(element.querySelector("span").classList.contains("more")){
      element.innerHTML = "<span class='close'></span> Close";
    } else {
      element.innerHTML = "<span class='more'></span> Menu";
    }
}

/* MOBILE MODALS */
const navContainer = document.querySelector('.nav-container');
const hamburger = document.querySelector('#hamburger');
const hamburgerSearch = document.querySelector('#headerSearch');

const modalMobileNav = new tingle.modal({
  footer: false,
  closeMethods: ['escape'],
  cssClass: ['mobile-nav','reversed'],
  onOpen: function () {
    // Navigation height
    let headerHeight = 0;
    if (document.querySelector('.site-header').classList.contains('is-sticky')) {
      headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.top-bar').offsetHeight;
    } else {
      headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.top-bar').offsetHeight + (document.body.getBoundingClientRect().top + window.scrollY);
    }
    document.querySelector('.mobile-nav.tingle-modal').setAttribute('style', `margin-top:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
    // document.querySelector('.site-menu') ? modalMobileNav.setFooterContent(document.querySelector('#price-switch').outerHTML) : null;
    // priceToggles();
  }
});
document.querySelector('.site-menu') ? modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML) : null;

// Nav modal
const handleToggle = () => {
  hamburger.classList.toggle('active');
  hamburger.classList.toggle('is-active');
  navContainer.classList.toggle('is-active');
  // hamburger.parentElement.classList.toggle('active');

  if(hamburger.classList.contains("active")) {
    // modalMobileSearch.close();
    modalMobileNav.open();
  } else{
    modalMobileNav.close();
  }
}

hamburger.onclick = () => handleToggle();
hamburger.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggle();
  }
});
/* END MOBILE MODALS */

// Review Video Modals
const videoButton = document.querySelectorAll('.deal-gallery-main.video-trigger');
const videoModal = new tingle.modal({
  footer: false,
  closeMethods: ['overlay', 'button', 'escape'],
  closeLabel: "Close",
  cssClass: ['video-modal'],
  onClose: function() {
    this.setContent('');
  }
});
videoButton.forEach((value) => {
  value.addEventListener("click", function(e){
    const videoWrapper = document.querySelector('#review-video');
    const videoWrapperClone = videoWrapper.cloneNode(true);
    if (videoWrapperClone) {
      videoModal.setContent(videoWrapperClone);
      videoModal.open();
      videoWrapperClone.querySelector('video').play();
    }
  })
})
// END Review Video Modals

// Search Bar
var searchDropdown = function(){
    var searchRow = this.closest('.search-bar');
    searchRow.classList.toggle("active");
}

var searchBar = document.querySelectorAll(".search-bar .legend");

for(var i=0; i<searchBar.length; i++){
  searchBar[i].addEventListener('click', searchDropdown, false);
}


if(document.getElementsByClassName('toggle-search').length>0){
  document.getElementsByClassName('toggle-search')[0].addEventListener('click', function(e){
    e.preventDefault();
    if(document.querySelector('#popout-form')===null){
      window.location.href='/search';
      return false;
    }
    if(document.querySelector('#popout-form').classList.contains('hidden')){
      document.querySelector('#popout-form').classList.remove('hidden');
    } else {
      document.querySelector('#popout-form').classList.add('hidden');
    }
  });
}
function setUrlParams(param, value, module, multiple ) {
  let searchUrl = new URL(window.location.origin + window.location.pathname);
  if (module === 'Search') {
    if (window.location.search.includes('offers=specials')) {
      searchUrl.searchParams.set('offers', 'specials');
    } else if (window.location.search.includes('offers=stock')) {
      searchUrl.searchParams.set('offers', 'stock');
    }
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('order', 'offers');
    searchUrl.searchParams.set('search-type', document.querySelector('#search-type').value);
  } else if (window.location.pathname === '/car-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('order', 'offers');
    searchUrl.searchParams.set('search-type', 'car');
  } else if (window.location.pathname === '/van-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('order', 'offers');
    searchUrl.searchParams.set('search-type', 'van');
  } else {
    (value==='van') ? searchUrl = new URL(window.location.origin + '/van-leasing' + window.location.pathname) : null;
    (value==='car') ? searchUrl = new URL(window.location.origin + (window.location.pathname).replace('/van-leasing', '')) : null;
    searchUrl.searchParams.set('filter', 'true');
  }
  if(param==='type'){
    searchUrl.searchParams.set('make', '');
    searchUrl.searchParams.set('model', '');
    searchUrl.searchParams.set('spec_level', '');
    searchUrl.searchParams.set('body_type', '');
  } else {
    searchUrl.searchParams.set('make', param==='make' ? value : (document.querySelector('.search-aside [name="make"]') ? document.querySelector('.search-aside [name="make"]').value : ''));
    searchUrl.searchParams.set('model', param==='model' ? value : (document.querySelector('.search-aside [name="model"]') ? document.querySelector('.search-aside [name="model"]').value : ''));
    searchUrl.searchParams.set('spec_level', param==='spec_level' ? value : (document.querySelector('.search-aside [name="spec_level"]') ? document.querySelector('.search-aside [name="spec_level"]').value : ''));
    searchUrl.searchParams.set('body_type', param==='body_type' ? value : (document.querySelector('.search-aside [name="body_type"]') ? document.querySelector('.search-aside [name="body_type"]').value : ''));
    // if (document.querySelectorAll('.search-form input[name="body_type"]:checked') && (document.querySelectorAll('.search-form input[name="body_type"]:checked').length > 1)){
    //   document.querySelectorAll('.search-form input[name="body_type"]:checked').forEach(v => {
    //     searchUrl.searchParams.append('body_type[]', v.value)
    //   })
    // } else {
    //   searchUrl.searchParams.set('body_type', (param==='body_type') ? value : (document.querySelector('.search-aside input[name="body_type"]:checked') ? document.querySelector('.search-aside input[name="body_type"]:checked').value : ''));
    // }
    if(param==='make'){
      searchUrl.searchParams.delete('model');
      searchUrl.searchParams.delete('spec_level');
      if (document.querySelectorAll('.search-form input[name="body_type"]:checked') && (document.querySelectorAll('.search-form input[name="body_type"]:checked').length > 1)){
        searchUrl.searchParams.delete('body_type[]');
      } else {
        searchUrl.searchParams.delete('body_type');
      }
    }
    if(param==='model'){
      searchUrl.searchParams.delete('spec_level');
      searchUrl.searchParams.delete('body_type');
    }
  }

  searchUrl.searchParams.set('transmission', param==='transmission' ? value : (document.querySelector('.search-aside input[name="transmission"]:checked') ? document.querySelector('.search-aside input[name="transmission"]:checked').value : ''));
  if (document.querySelectorAll('.search-form input[name="fuel_type"]:checked') && (document.querySelectorAll('.search-form input[name="fuel_type"]:checked').length > 1)){
    document.querySelectorAll('.search-form input[name="fuel_type"]:checked').forEach(v => {
      searchUrl.searchParams.append('fuel_type[]', v.value)
    })
  } else {
    searchUrl.searchParams.set('fuel_type', (param==='fuel_type') ? value : (document.querySelector('.search-aside input[name="fuel_type"]:checked') ? document.querySelector('.search-aside input[name="fuel_type"]:checked').value : ''));
  }
  searchUrl.searchParams.set('co2', param==='co2' ? value : (document.querySelector('.search-aside input[name="co2"]:checked') ? document.querySelector('.search-aside input[name="co2"]:checked').value : ''));
  searchUrl.searchParams.set('budget-min', param==='budget-min' ? value : (document.querySelector('.search-aside input[name="budget-min"]:checked') ? document.querySelector('.search-aside input[name="budget-min"]:checked').value : ''));
  searchUrl.searchParams.set('budget-max', param==='budget-max' ? value : (document.querySelector('.search-aside input[name="budget-max"]:checked') ? document.querySelector('.search-aside input[name="budget-max"]:checked').value : ''));
  // searchUrl.searchParams.set('co2', param==='co2' ? value : (document.querySelector('.search-aside input[name="co2"]:checked') ? document.querySelector('.search-aside input[name="co2"]:checked').value : ''));
  // searchUrl.searchParams.set('term', param==='term' ? value : (document.querySelector('.search-aside [name="term"]') ? document.querySelector('.search-aside [name="term"]').value : ''));
  // searchUrl.searchParams.set('initial_profile', param==='initial_profile' ? value : (document.querySelector('.search-aside [name="initial_profile"]') ? document.querySelector('.search-aside [name="initial_profile"]').value : ''));
  // searchUrl.searchParams.set('mileage', param==='mileage' ? value : (document.querySelector('.search-aside [name="mileage"]') ? document.querySelector('.search-aside [name="mileage"]').value : ''));
  searchUrl.searchParams.set('order', param==='order' ? value : (document.querySelector('.search-heading select[name="order"]') ? document.querySelector('.search-heading select[name="order"]').value : ''));

  let path = window.location.search;
  let v = `&${param}%5B%5D=${value}`;
  if (multiple=='true') {
    if (path.includes(v)) {
      path = path.replace(v, '');
      window.location.href = window.location.origin + window.location.pathname + path;
    } else {
      (path.includes(`&${param}=`) ? path = path.replace(`&${param}=`, `&${param}%5B%5D=`) : null)
      path = path.replace(`&${param}%5B%5D`, v+ `&${param}%5B%5D`);
      window.location.href = window.location.origin + window.location.pathname + path;
    }
  } else if (path.includes(`body_type`) && param === `body_type` && !path.includes(`&body_type=&`)) {
    (path.includes(`&body_type=${value}`) ? path = path.replace(`&body_type=${value}`, ``) : null);
    (path.includes(`&body_type=`) && !path.includes(`&body_type=${value}`) ? path = path.replace(`&body_type=`, `&body_type%5B%5D=${value}&body_type%5B%5D=`) : null);
    window.location.href = window.location.origin + window.location.pathname + path;
  } else if (path.includes(`fuel_type`) && param === `fuel_type` && !path.includes(`&fuel_type=&`)) {
    (path.includes(`&fuel_type=${value}`) ? path = path.replace(`&fuel_type=${value}`, ``) : null);
    (path.includes(`&fuel_type=`) && !path.includes(`&fuel_type=${value}`) ? path = path.replace(`&fuel_type=`, `&fuel_type%5B%5D=${value}&fuel_type%5B%5D=`) : null);
    window.location.href = window.location.origin + window.location.pathname + path;
  } else {
    window.location.href = searchUrl;
  }
}

const searchSorter = document.querySelector('#search-sorter');
if (searchSorter) {
  searchSorter.addEventListener('change', (e) => {
    setUrlParams('order', e.target.value, document.querySelector('.search-content').dataset.module);
    // const urlParams = new URLSearchParams(window.location.search);
    // urlParams.set('order', e.target.value);
    // window.location.search = urlParams;
  })
}

const searchReset = document.querySelector('.quick-search button.reset-form');
if (searchReset) {
  const allFields = document.querySelectorAll('.search-form .form-group select');
  searchReset.addEventListener('click', (e) => {
    allFields.forEach(value => {
      value.selectedIndex = 0;
      loadModels();
      loadSpecs();
    })
  })
}

// Show More
const showMoreButton = document.querySelector('#show-more');
const headerContent = document.querySelector('#manufacturer-header-content');
if(showMoreButton){
  if (showMoreButton.parentElement.querySelectorAll('.header-description > *').length > 1) {
    showMoreButton.addEventListener('click', (e) => {
      console.log('click')
      headerContent.classList.toggle('header-content--full');
      showMoreButton.classList.toggle('active');
      (showMoreButton.classList.contains('active')) ? showMoreButton.querySelector('span').innerText = 'Show less' : showMoreButton.querySelector('span').innerText = 'Read more';
    })
  } else {
    showMoreButton.classList.add('visuallyhidden')
  }
}


//Menu Dropdown Toggle
// var menuDropdown = function(){
//     var dropdown = this;
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }

// //Dropdown Button
// var showDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var dropdownButton = document.querySelectorAll(".dropdown > button");

// for(var i=0; i<dropdownButton.length; i++){
//   dropdownButton[i].addEventListener('click', showDropdown, false);
// }

// //Dropdown Toggle
// var showDropdown = function(){
//     var dropdown = this.querySelector('div');
//     dropdown.classList.toggle("active");
// }

// var has_dropdown = document.querySelectorAll(".has-dropdown");

// for(var i=0; i<has_dropdown.length; i++){
//   has_dropdown[i].addEventListener('click', showDropdown, false);
// }

// // Mobile Dropdown
// var mobileDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var mobile_dropdown = document.querySelectorAll(".breadcrumb-menu");

// for(var i=0; i<mobile_dropdown.length; i++){
//   mobile_dropdown[i].addEventListener('click', mobileDropdown, false);
// }


// Site Search Toggle
// var searchToggle = function(){
//   search_container = document.querySelector(".popout-form");
//   if(search_container){
//     search_container.classList.toggle("active");
//   } else {
//     var elmnt = document.querySelector(".full-header-search");
//     elmnt.scrollIntoView();
//   }
// }

// var search_toggle = document.getElementById('search-toggle');
// search_toggle.addEventListener('click', searchToggle , false);



//Site Menu Dropdown Toggle
var menuDropdown = function(){
    //div inside element contains dropdown menu
    var dropdown = this.parentNode;

    //if it's already active set it not to be
    if(dropdown.classList.contains("active")){
        dropdown.classList.toggle("active");
        return;
    }
    //get current active class
    var activeClass = document.querySelectorAll(".menu-dropdown.active");
    // make it not active
    if(activeClass!=null){
        for(var i=0; i<activeClass.length; i++){
          activeClass[i].classList.toggle("active");
        }
    }
    
    //apply active to the div inside element that contains dropdown menu
    dropdown.classList.toggle("active");
}

var dropdownTrigger = document.querySelectorAll(".menu-dropdown > a");

for(var i=0; i<dropdownTrigger.length; i++){
  dropdownTrigger[i].addEventListener('click', menuDropdown, false);
}


// //Menu Dropdown Toggle
// var menuDropdown = function(){
//     //div inside element contains dropdown menu
//     var dropdown = this.parentNode.querySelector(".menu-dropdown");

//     //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     // //get current active class
//     // var activeClass = document.querySelectorAll(".menu-dropdown.active");
//     // // make it not active
//     // if(activeClass!=null){
//     //     for(var i=0; i<activeClass.length; i++){
//     //       activeClass[i].classList.toggle("active");
//     //     }
//     // }
    
//     //apply active to the div inside element that contains dropdown menu
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown > a");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }


//Dropdown Menu Toggle
var showMenu = function(){
  //div inside element contains dropdown menu
  var dropdown = this.parentNode.querySelector('div');
  var menuToggle = this;

  //if it's already active set it not to be
  if(dropdown.classList.contains("active")){
    dropdown.classList.toggle("active");
    menuToggle.classList.toggle("active");
    dropdown.classList.toggle("is-active");
    menuToggle.classList.toggle("is-active");
    return;
  }
  //get current active class
  var activeClass = document.querySelectorAll(".dropdown-menu .active");
  // make it not active
  if(activeClass!=null){
    for(var i=0; i<activeClass.length; i++){
      activeClass[i].classList.toggle("active");
      activeClass[i].classList.toggle("is-active");
    }
  }

  //apply active to the div inside element that contains dropdown menu
  dropdown.classList.toggle("active");
  dropdown.classList.toggle("is-active");
  menuToggle.classList.toggle("active");
  menuToggle.classList.toggle("is-active");
}

var menuDropdown = document.querySelectorAll(".dropdown-menu > a");

for(var i=0; i<menuDropdown.length; i++){
  menuDropdown[i].addEventListener('click', showMenu, false);
}

// Toggle class for accordions
let acc = document.getElementsByClassName('mobile-accordion-header');
for (let i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function(ev) {

    for (let i = 0; i < acc.length; i++) {
      if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
        continue;
      }
      acc[i].parentElement.classList.remove('active');
    }

    if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')){
      setTimeout(() => { document.documentElement.scrollTop += this.getBoundingClientRect().top; }, 500);
    }
    this.parentElement.classList.toggle("active");

  });
}

//Dropdown Menu Toggle
// var mobileDropdown = function(){
//   //div inside element contains dropdown menu
//   var dropdown = this.parentNode.querySelector('div');


//   //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     //get current active class
//     var activeClass = document.querySelectorAll(".mobile-dropdown .active");
//     // make it not active
//     if(activeClass!=null){
//         for(var i=0; i<activeClass.length; i++){
//           activeClass[i].classList.toggle("active");
//         }
//     }

  
//   //apply active to the div inside element that contains dropdown menu
//   dropdown.classList.toggle("active");
// }

// var mobileMenu = document.querySelectorAll(".mobile-dropdown > a");

// for(var i=0; i<mobileMenu.length; i++){
//   mobileMenu[i].addEventListener('click', mobileDropdown, false);
// }


//faqs
var faqSearch = document.querySelector('.faq-search input');
if(faqSearch !== null){
  faqSearch.addEventListener('keyup', function(e){
    var results = document.getElementById('faq-results');
    if(this.value.length != 0){
      results.classList.add("active");
    } else {
      results.classList.remove("active");
    }
  });
}

//More Options Toggle
var classname = document.querySelectorAll(".more-options");

var moreOptions = function(e) {
	e.preventDefault();
  var element = document.getElementById("vehicle-search");
  element.classList.toggle("active");
  if(element.classList.contains('active')){
    this.innerHTML = 'Hide additional options';
  } else {
    this.innerHTML = 'Show me more options';
  }
};

for (var i = 0; i < classname.length; i++) {
    classname[i].addEventListener('click', moreOptions, false);
}

//Tab Content
function openTab(e, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-content");
  tablinks = document.getElementsByClassName("tab");

  //remove active tab
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].className = tabcontent[i].className.replace(" active", "");
  }

  //remove active from button tabs
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  //add active to tab
  document.getElementById(tabName).className += " active";

  //add active to button tabs
  e.currentTarget.className += " active";
}

//Search for Cars or Vans
function showDesc(el){
  el.style.display = 'none';
  el.parentNode.querySelector('.extra').classList.remove('visuallyhidden');
}

/** 
  * SEARCH
  */

function loadUrlParams() {
  const urlParams = new URLSearchParams(window.location.search);
  setTimeout(() => {
    urlParams.forEach((value, key) => {
      document.querySelector(`.search-form [name=${key}]`) ? document.querySelector(`.search-form [name=${key}]`).value = value : null;
      document.querySelector(`.search-form [name=${key}]`) ? document.querySelector(`.search-form [name=${key}]`).dispatchEvent(new Event('change')) : null;
    })
  }, 1500);
}

function searchType(elem, searchType) {
  document.querySelector('.search-form [name=model]') ? document.querySelector('.search-form [name=model]').parentElement.classList.add('visuallyhidden') : null;
  document.querySelector('.search-form [name=spec_level]') ? document.querySelector('.search-form [name=spec_level]').parentElement.classList.add('visuallyhidden') : null;
  let hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.querySelector('#search-type');
  hiddenField.setAttribute('value', searchType);
  hiddenField.dispatchEvent(new Event('change'));

  //remove active class
  searchTab = document.querySelectorAll('.search-tab');
  (searchTab) ? searchTab.forEach(v => { v.classList.toggle('active') }) : null;

  //add active class to clicked
  // elem.classList.toggle("active");

  loadManufacturers(hiddenField.value);
  loadBodyTypes(hiddenField.value, false);
  loadSpecs(hiddenField.value);

  let dropdown = document.querySelectorAll('[name="model"]');
  if (dropdown) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Choose a Model';
    defaultOption.value = '';
    dropdown.forEach(v => {
      v.length = 0;
      v.add(defaultOption);
      v.selectedIndex = 0;
    })
  }
}

function loadManufacturers($type) {
  if ($type) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Choose a Manufacturer';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';
    document.querySelectorAll('[name="make"]').forEach((v, i) => {
      v.length = 0;
      v.add(loadingOption);
      v.selectedIndex = 0;
      let url = '/api/'+$type+'/manufacturers';
      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        v.length = 0;
        v.add(defaultOption);
        v.selectedIndex = 0;
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]].toUpperCase();
          option.value = keysSorted[x];
          v.add(option);
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    })
  }
}

function loadEvManufacturers($type) {
  var make_dropdowns = document.getElementsByName("make");
  for (i = 0; i < make_dropdowns.length; i++) {

    var dropdown = make_dropdowns[0];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Make';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    var url = '/api/' + $type + '/manufacturers/ev';

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let option = document.createElement('option');
        option.text = data[keysSorted[x]];
        option.value = keysSorted[x];
        dropdown.add(option);
      }
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.has('make') ? document.querySelector('.search-form [name="make"]').value = urlParams.get('make') : null;
      urlParams.has('make') ? document.querySelector('.search-form [name="make"]').dispatchEvent(new Event('change')) : null;
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

// function loadEvManufacturers($type) {
//   var make_dropdowns = document.getElementsByName("make");
//   for (i = 0; i < make_dropdowns.length; i++) {
//
//     var dropdown = make_dropdowns[0];
//     dropdown.length = 0;
//
//     var defaultOption = document.createElement('option');
//     defaultOption.text = 'Any Manufacturer';
//     defaultOption.value = '';
//
//     dropdown.add(defaultOption);
//     dropdown.selectedIndex = 0;
//
//     if($type) {
//       let url = '/api/' + $type + '/manufacturers/ev';
//       fetch(url).then(function (response) {
//         if (response.status !== 200) {
//           console.warn('Looks like there was a problem. Status Code: ' +
//             response.status);
//           return;
//         }
//         return response.json();
//       }).then(function (data) {
//         let keysSorted = Object.keys(data).sort(function (a, b) {
//           return data[a].localeCompare(data[b])
//         });
//         for (let x in keysSorted) {
//           let option = document.createElement('option');
//           option.text = data[keysSorted[x]];
//           option.value = keysSorted[x];
//           dropdown.add(option);
//         }
//       }).catch(function (err) {
//         console.error('Fetch Error -', err);
//       });
//
//     }
//   }
// }

function loadModels($type, $manufacturer) {
  if ($type && $manufacturer) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Choose a Model';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';

    var model_dropdowns = document.getElementsByName("model");
    for (let i = 0; i < model_dropdowns.length; i++) {
      var dropdown = model_dropdowns[i];
      dropdown.length = 0;
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      if ($manufacturer) {
        dropdown.length = 0;
        dropdown.add(loadingOption);
        dropdown.selectedIndex = 0;

        var url = '/api/'+$type+'/models/'+$manufacturer;

        if(window.location.pathname.includes('/used-evs')) {
          url = '/api/used-evs/models/' + $manufacturer;
        }

        fetch(url).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          dropdown.length = 0;
          dropdown.add(defaultOption);
          dropdown.selectedIndex = 0;
          let keysSorted = Object.keys(data).sort(function(a, b) {
            return data[a].localeCompare(data[b])
          });
          for (let x in keysSorted) {
            let option = document.createElement('option');
            option.text = data[keysSorted[x]];
            option.value = keysSorted[x];
            dropdown.add(option);
          }
          const urlParams = new URLSearchParams(window.location.search);
          const makeParam = urlParams.get('make');
          const modelParam = urlParams.get('model');
          if (modelParam && makeParam == $manufacturer) {
            dropdown.value = modelParam;
            loadSpecs($type, modelParam);
          }
        }).catch(function(err) {
          dropdown.length = 0;
          dropdown.add(loadingError);
          dropdown.selectedIndex = 0;
          console.error('Fetch Error -', err);
        });
      }
    }
  }
}

function loadEvModels($type, $manufacturer) {

  let defaultOption = document.createElement('option');
  defaultOption.text = 'Any Model';
  defaultOption.value = '';
  let loadingOption = document.createElement('option');
  loadingOption.text = 'Loading...';
  loadingOption.value = '';
  let loadingError = document.createElement('option');
  loadingError.text = 'Loading Error, please check your internet connection';
  loadingError.value = '';

  var model_dropdowns = document.getElementsByName("model");
  for (let i = 0; i < model_dropdowns.length; i++) {
    var dropdown = model_dropdowns[i];
    dropdown.length = 0;
    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    if ($manufacturer) {
      dropdown.length = 0;
      dropdown.add(loadingOption);
      dropdown.selectedIndex = 0;

      let url = '/api/' + $type + '/models/' + $manufacturer + '/ev';

      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        dropdown.length = 0;
        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
        const urlParams = new URLSearchParams(window.location.search);
        const makeParam = urlParams.get('make');
        const modelParam = urlParams.get('model');
        if (modelParam && makeParam == $manufacturer) {
          dropdown.value = modelParam;
          loadSpecs($type, modelParam);
        }
      }).catch(function(err) {
        dropdown.length = 0;
        dropdown.add(loadingError);
        dropdown.selectedIndex = 0;
        console.error('Fetch Error -', err);
      });
    }
  }
}

// function loadEvModels($type, $manufacturer) {
//   var model_dropdowns = document.getElementsByName("model");
//   for (let i = 0; i < model_dropdowns.length; i++) {
//     var dropdown = model_dropdowns[i];
//     dropdown.length = 0;
//
//     var defaultOption = document.createElement('option');
//     defaultOption.text = 'Any Model';
//     defaultOption.value = '';
//
//     dropdown.add(defaultOption);
//     dropdown.selectedIndex = 0;
//
//     if($type && $manufacturer) {
//       let url = '/api/' + $type + '/models/' + $manufacturer + '/ev';
//
//       fetch(url).then(function (response) {
//         if (response.status !== 200) {
//           console.warn('Looks like there was a problem. Status Code: ' +
//             response.status);
//           return;
//         }
//         return response.json();
//       }).then(function (data) {
//         let keysSorted = Object.keys(data).sort(function (a, b) {
//           return data[a].localeCompare(data[b])
//         });
//         for (let x in keysSorted) {
//           let option = document.createElement('option');
//           option.text = data[keysSorted[x]];
//           option.value = keysSorted[x];
//           dropdown.add(option);
//         }
//       }).catch(function (err) {
//         console.error('Fetch Error -', err);
//       });
//
//     }
//   }
//
// }

function loadBodyTypes($type, $van_sizes = false) {
  let dropdown = document.querySelector('[name=body_type]');
  if (dropdown && $type) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Choose a Bodytype';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';
    dropdown.length = 0;

    dropdown.length = 0;
    dropdown.add(loadingOption);
    dropdown.selectedIndex = 0;

    let url = '/api/'+$type+'/types';

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      dropdown.length = 0;
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      if ($van_sizes && $type === 'van') {
        let van_sizes = { "small": "Small", "medium": "Medium", "large": "Large", "pickup": "Pickup" };
        Object.entries(van_sizes).forEach(([key, value]) => {
          let option = document.createElement('option');
          option.text = value;
          option.value = key;
          dropdown.add(option);
        });
      } else {
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }
    }).catch(function(err) {
      dropdown.length = 0;
      dropdown.add(loadingError);
      dropdown.selectedIndex = 0;
      console.error('Fetch Error -', err);
    });
  }
}

function loadSpecs($type, $model) {
  if ($type && $model) {
    var dropdown = document.getElementsByName('spec_level')[0];
    if (dropdown){
      let defaultOption = document.createElement('option');
      defaultOption.text = 'Choose Spec';
      defaultOption.value = '';
      let loadingOption = document.createElement('option');
      loadingOption.text = 'Loading...';
      loadingOption.value = '';
      let loadingError = document.createElement('option');
      loadingError.text = 'Loading Error, please check your internet connection';
      loadingError.value = '';

      dropdown.length = 0;
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      if ($model) {
        dropdown.length = 0;
        dropdown.add(loadingOption);
        dropdown.selectedIndex = 0;
        var url = '/api/'+$type+'/specs/'+$model;

        fetch(url).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          if (data.length === 0) {
            document.querySelector('.search-form [name=spec_level]').parentElement.classList.add('visuallyhidden');
          }
          dropdown.length = 0;
          dropdown.add(defaultOption);
          dropdown.selectedIndex = 0;
          let keysSorted = Object.keys(data).sort(function(a, b) {
            return data[a].localeCompare(data[b])
          });
          for (let x in keysSorted) {
            let option = document.createElement('option');
            option.text = data[keysSorted[x]];
            option.value = keysSorted[x];
            dropdown.add(option);
          }
          const urlParams = new URLSearchParams(window.location.search);
          const modelParam = urlParams.get('model');
          const specParam = urlParams.get('spec_level');
          if (specParam && modelParam == $model) {
            dropdown.value = specParam;
          }
        }).catch(function(err) {
          dropdown.length = 0;
          dropdown.add(loadingError);
          dropdown.selectedIndex = 0;
          console.error('Fetch Error -', err);
        });
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", function() {

  // Pagination
  document.querySelectorAll('.pagination-holder .results-per-page select option')?.forEach(v => { (v.innerHTML = v.innerHTML.replace('Show', '<span>Results Per Page:</span>')) })
  document.querySelector('.pagination-holder .results-per-page select option[value="All"]')?.setAttribute('value', '9999')
  let first_option = document.querySelector('.pagination-holder .results-per-page select option[value="10"]');
  if (first_option) {
    let url = first_option.dataset.url.replace('show=10', 'show=20')
    first_option.innerHTML = "<span>Results Per Page:</span> 20";
    first_option.setAttribute('data-url', url);
    first_option.setAttribute('value', '20');
  }
  let url = new URL(document.URL);
  url.searchParams.has('show') ? (url.searchParams.get('show') === '9999' ? document.querySelector('.pagination-holder .results-per-page select').selectedIndex = 6 : null) : null;

  document.querySelector('.pagination-holder .results-per-page select')?.addEventListener('change', ev => {
    url.searchParams.set('show', (ev.target.value === 'All') ? '9999' : ev.target.value);
    url.searchParams.has('page') ? url.searchParams.delete('page') : null;
    window.location.href = url;
  })
  // END Pagination

  // Feefo Reviews
  const xhttp = new XMLHttpRequest();
  xhttp.onload = function() {
    let reviewsTop = document.querySelector('#feefo_top');
    if(this.response && reviewsTop){
      reviewsTop.querySelector('#reviews_text > tspan:first-child').innerHTML = `${JSON.parse(this.response).rating.rating}`;
      reviewsTop.querySelector('#reviews_text > tspan:last-child').innerHTML = `${JSON.parse(this.response).meta.count} Reviews`;
      reviewsTop.parentElement.setAttribute('href', JSON.parse(this.response).merchant.review_url)
      reviewsTop.classList.remove('visuallyhidden');
    } else {
      reviewsTop ? reviewsTop.classList.add('visuallyhidden') : null;
    }

    let reviewsHero = document.querySelector('#feefo_hero');
    if(this.response && reviewsHero) {
      reviewsHero.querySelector('#reviews_text > tspan:first-child').innerHTML = `${JSON.parse(this.response).rating.rating}`;
      reviewsHero.parentElement.setAttribute('href', JSON.parse(this.response).merchant.review_url)
      reviewsHero.classList.remove('visuallyhidden');
    } else {
      reviewsHero ? reviewsHero.classList.add('visuallyhidden') : null;
    }

  }
  xhttp.open("GET", "https://api.feefo.com/api/20/reviews/summary/all?merchant_identifier=planet-leasing&since_period=all");
  xhttp.send();

  // Search Sidebar
  // let filterSwitch = document.querySelectorAll('.filter-switch');
  // if(filterSwitch){
  //   Array.prototype.slice.call(filterSwitch, 0).forEach((value) => {
  //     value.addEventListener('click', () => {
  //       document.querySelector('#page').classList.toggle('open');
  //       document.querySelector('.search-results-filters').classList.toggle('open');
  //       // document.querySelector('.search-results-filters-switch').classList.toggle('open');
  //     })
  //   })
  // }
  // let breadcrumbsSwitch = document.querySelector('.breadcrumbs-search.filter-switch');
  // if (breadcrumbsSwitch){
  //   document.querySelector('#page').classList.add('has-search');
  // }
  // let searchPage = document.querySelector('.breadcrumbs.search-page');
  // if (searchPage){
  //   document.querySelector('#page').classList.add('search-page');
  // }
  // END Search Sidebar

  // Latest Offers - Show More
  // document.querySelectorAll('.offers-strip-more').forEach(value => {
  //   value.addEventListener('click', (e) => {
  //     e.target.closest('.offers-strip').classList.toggle('show-more');
  //   })
  // })

  document.querySelectorAll('.offers-strip-more').forEach(value => {
    value.addEventListener('click', (e) => {
      let element = e.target.closest('.offers-strip');
      let showMore = element.querySelector('span.show-more-btn');

      element.classList.toggle('show-more');
      if(element.classList.contains('show-more')){
        showMore.innerHTML = 'Show less';
      } else {
        showMore.innerHTML = 'Show more';
      }
    })
  })

  // var classname = document.querySelectorAll(".offers-strip-more");
  //
  // var showMore = function(e) {
  //   e.preventDefault();
  //   let element = classname.closest('.offers-strip');
  //   element.classList.toggle("active");
  //   if(element.classList.contains('active')){
  //     this.innerHTML = 'Hide additional options';
  //   } else {
  //     this.innerHTML = 'Show me more options';
  //   }
  // };
  //
  // for (var i = 0; i < classname.length; i++) {
  //   classname[i].addEventListener('click', showMore, false);
  // }

  // Model Table Search
  if (document.querySelector('#model-table')) {
    let filterFields = document.querySelectorAll('.model-table-head select');
    const filterTable = (field, value) => {
      let searchType = field;

      if (value !== '' && value.length > 0) {
        let elements = document.querySelectorAll('.model-table-wrapper[data-' + searchType + ']');
        console.log(elements)
        elements.forEach((v) => {
          v.classList.add('hidden-' + field + '')
          if(v.getAttribute('data-' + searchType + '').includes(value)) {
            v.classList.remove('hidden-' + field + '')
          }
        })
      } else {
        document.querySelectorAll('.model-table-wrapper[data-' + searchType + ']').forEach((v) => {
          v.classList.remove('hidden-' + field + '')
        });
      }

      // Show no results text
      if(!document.querySelectorAll('.model-table-wrapper:not([class*="hidden"]):not(.no-results)').length > 0) {
        document.querySelector('.no-results').classList.remove('hidden-no-results', 'hidden');
      } else {
        document.querySelector('.no-results').classList.add('hidden-no-results');
      }
    }
    if (filterFields) {
      filterFields.forEach((value => {
        value.addEventListener('change', (event) => {
          let val = value.value;
          let field = value.getAttribute('name');
          filterTable(field, val);
        })
      }))
    }
    // let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
    // allSwitches.forEach((value) => {
    //   value.addEventListener('change', (val) => {
    //     filterTable('personal', '');
    //     filterTable('business', '');
    //     document.querySelector('#filterBudget').selectedIndex = 0;
    //     document.querySelector('#filterBudgetBusiness').selectedIndex = 0;
    //   })
    // })
  }
  // End Model Table Search

  // Hero Slider
  const heroSlider = document.querySelector('#hero-offer-wrapper > div:not(.glider-arrows)')
  if (heroSlider) {
    new Glider(heroSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: false,
      scrollLock: true,
      arrows: {
        prev: '#hero-offer-wrapper .glider-prev',
        next: '#hero-offer-wrapper .glider-next'
      },
      responsive: [
        {
          breakpoint: 769,
          settings: {
            draggable: false,
          }
        }
      ]
    })
  }

  // Derivative Gallery Slider
  const dealGallerySlider = document.querySelector('.deal-gallery-track');
  if (dealGallerySlider) {
    new Glider(dealGallerySlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-gallery-controls .glider-prev',
        next: '.deal-gallery-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 5,
          }
        }
      ]
    })
  }
  // END Derivative Gallery Slider


  // Toggle Offer Filters
  document.getElementById('filter-btn') ? document.getElementById('filter-btn').addEventListener('click', (e) => {e.preventDefault();document.getElementById('filter-btn').classList.toggle('hidden');document.querySelector('#offer-filters').classList.toggle('hidden');}) : '';

});

// Contact Form
if(document.getElementById('send-contact-form')){
  // Do captcha and submit form

  let button = document.querySelector('#send-contact-form');
  let terms = document.querySelector('#contact-form [name=terms]');
  terms.onchange = function() {
    button.disabled = !this.checked;
  };

  document.getElementById('send-contact-form').addEventListener("click", function(e) {
    e.preventDefault();

    document.body.classList.remove('loaded');
    button.disabled = true;
    button.innerHTML = 'Sending...';

    grecaptcha.ready(function() {
      grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
        document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

        let url = '/contact';
        let email = document.querySelector('#contact-form [name=email]').value;
        let forename = document.querySelector('#contact-form [name=forename]').value;
        let surname = document.querySelector('#contact-form [name=surname]').value;
        let telephone = document.querySelector('#contact-form [name=telephone]').value;
        let postcode = document.querySelector('#contact-form [name=postcode]').value;
        let comments = document.querySelector('#contact-form [name=comments]').value;
        let callback = '';
        if (document.querySelector('#contact-form [name=date]') && document.querySelector('#contact-form [name=time]')){
          callback =`${document.querySelector('#contact-form [name=date]').value} ${document.querySelector('#contact-form [name=time]').value}`;
        }
        let csrf_token = document.querySelector('#contact-form [name=_token]').value;

        if (document.querySelector('#contact-form [name=subscribe]').checked) {
          fetch((typeof $base_path !== 'undefined' ? $base_path : '')+'/newsletter', {
            method: 'POST', // or 'PUT'
            body: JSON.stringify({
              'name': forename+' '+surname,
              'forename': forename,
              'surname': surname,
              'email': email,
              'mail_status': 'subscribed',
              '_token': csrf_token }),
            headers:{
              'Content-Type': 'application/json'
            }}).then(function(response) {
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' + response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            if(data.status !== 'ok'){
              let errors = '';
              for (let i in data.errors) {
                errors += data.errors[i][0]+'\n';
              }
              return alert('There was a problem with your sign up details\n\n'+errors);
            }

            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'Newsletter Signup'
            });

          }).catch(function(err) {
            console.error('Fetch Error -', err);
          });
        }

        fetch(url, {
          method: 'POST',
          body: JSON.stringify({
            'name': forename+' '+surname,
            'forename': forename,
            'surname': surname,
            'email': email,
            'telephone': telephone,
            'comments': `POSTCODE: ${postcode} \n\r ADDITIONAL INFORMATION: ${comments}`,
            'callback_time': callback,
            '_token': csrf_token,
            'g-recaptcha-response': recaptcha_token
          }),
          headers:{
            'Content-Type': 'application/json'
          }}).then(function(response) {
          document.body.classList.add('loaded');
          button.disabled = false;
          button.innerHTML = 'Submit Enquiry';
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          if(data.status !== 'ok'){
            let errors = '';
            for (var i in data.errors) {
              errors += data.errors[i][0]+'\n';
            }
            button.disabled = false;
            button.innerHTML = 'Submit Enquiry';
            return alert('There was a problem with your form\n\n'+errors);
          }

          button.disabled = false;
          button.innerHTML = 'Submit Enquiry';
          document.getElementsByClassName('contact-form')[0].reset();
          document.getElementsByClassName('contact-content')[0].classList.add('hidden');
          document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
          document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

          // Trigger event tracking
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'General Enquiry Received'
          });


        }).catch(function(err) {
          document.body.classList.add('loaded');
          console.error('Fetch Error -', err);
          return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
        });

      });
    });

  });
}

// Signup Form
if(document.getElementById('send-signup-form')){
  // Do captcha and submit form

  let button = document.querySelector('#send-signup-form');
  let terms = document.querySelector('#signup-form [name=terms]');
  terms.onchange = function() {
    button.disabled = !this.checked;
  };

  document.getElementById('send-signup-form').addEventListener("click", function(e) {
    e.preventDefault();

    document.body.classList.remove('loaded');
    button.disabled = true;
    button.innerHTML = 'Sending...';

    grecaptcha.ready(function() {
      grecaptcha.execute(document.getElementById('signup-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
        document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

        let url = '/contact';
        let email = document.querySelector('#signup-form [name=email]').value;
        let forename = document.querySelector('#signup-form [name=forename]').value;
        let surname = document.querySelector('#signup-form [name=surname]').value;
        let telephone = document.querySelector('#signup-form [name=telephone]').value;

        let vehicle = '';
        if (document.querySelector('#signup-form [name=search-type]')){
          vehicle =`${document.querySelector('#signup-form [name=search-type]').value}`;
        }
        let manufacturer = '';
        if (document.querySelector('#signup-form [name=make]')){
          manufacturer =`${document.querySelector('#signup-form [name="make"]').options[document.querySelector('#signup-form [name=make]').selectedIndex].text}`;
        }
        let model = '';
        if (document.querySelector('#signup-form [name=model]')){
          model =`${document.querySelector('#signup-form [name="model"]').options[document.querySelector('#signup-form [name=model]').selectedIndex].text}`;
        }

        let source = document.querySelector('#signup-form [name=source]').value;
        let campaign = document.querySelector('#signup-form [name=campaign]').value;

        let csrf_token = document.querySelector('#signup-form [name=_token]').value;
        let recaptcha = recaptcha_token;

        if (document.querySelector('#signup-form [name=subscribe]').checked) {
          fetch((typeof $base_path !== 'undefined' ? $base_path : '')+'/newsletter', {
            method: 'POST', // or 'PUT'
            body: JSON.stringify({
              'name': forename+' '+surname,
              'forename': forename,
              'surname': surname,
              'email': email,
              'source': source,
              'campaign': campaign,
              'mail_status': 'subscribed',
              '_token': csrf_token }),
            headers:{
              'Content-Type': 'application/json'
            }}).then(function(response) {
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' + response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            if(data.status !== 'ok'){
              let errors = '';
              for (let i in data.errors) {
                errors += data.errors[i][0]+'\n';
              }
              return alert('There was a problem with your sign up details\n\n'+errors);
            }

            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'Newsletter Signup'
            });

          }).catch(function(err) {
            console.error('Fetch Error -', err);
          });
        }

        fetch(url, {
          method: 'POST',
          body: JSON.stringify({
            'name': forename+' '+surname,
            'forename': forename,
            'surname': surname,
            'email': email,
            'telephone': telephone,
            'source': source,
            'campaign': campaign,
            'comments': `Vehicle Type: ${vehicle} \n\r Manufacturer: ${manufacturer} \n\r Model: ${model}`,
            '_token': csrf_token,
            'g-recaptcha-response': recaptcha
          }),
          headers:{
            'Content-Type': 'application/json'
          }}).then(function(response) {
          document.body.classList.add('loaded');
          button.disabled = false;
          button.innerHTML = 'Submit Enquiry';
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          if(data.status !== 'ok'){
            let errors = '';
            for (var i in data.errors) {
              errors += data.errors[i][0]+'\n';
            }
            button.disabled = false;
            button.innerHTML = 'Submit';
            return alert('There was a problem with your form\n\n'+errors);
          }

          button.disabled = false;
          button.innerHTML = 'Submit';
          document.getElementsByClassName('contact-form')[0].reset();
          document.getElementsByClassName('contact-content')[0].classList.add('hidden');
          document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
          document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

          // Trigger event tracking
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'General Enquiry Received'
          });


        }).catch(function(err) {
          document.body.classList.add('loaded');
          console.error('Fetch Error -', err);
          return alert('There was a problem sending your form. Please call us or use our general contact email address.');
        });

      });
    });

  });
}


// Map
// if(document.getElementById('map')){
//
//   let map_container = document.getElementById('map');
//   let map_zoom = map_container.dataset.zoom;
//   let map_lat_center = map_container.dataset.centerLat;
//   let map_lng_center = map_container.dataset.centerLng;
//   let map_lat = map_container.dataset.lat;
//   let map_lng = map_container.dataset.lng;
//   let map_lat_2 = map_container.dataset.lat2;
//   let map_lng_2 = map_container.dataset.lng2;
//   let map_lat_3 = map_container.dataset.lat3;
//   let map_lng_3 = map_container.dataset.lng3;
//
//   // Initialize and add the map
//   function initMap() {
//     var myOptions = {
//       center: { lat: parseFloat(map_lat_center), lng: parseFloat(map_lng_center) },
//       zoom: parseFloat(map_zoom),
//       disableDefaultUI: true,
//       mapTypeId: google.maps.MapTypeId.ROADMAP,
//       styles: [
//         {
//           "featureType": "administrative",
//           "elementType": "labels.text.fill",
//           "stylers": [
//             {
//               "color": "#444444"
//             }
//           ]
//         },
//         {
//           "featureType": "landscape",
//           "elementType": "all",
//           "stylers": [
//             {
//               "color": "#f2f2f2"
//             }
//           ]
//         },
//         {
//           "featureType": "landscape.man_made",
//           "elementType": "geometry.fill",
//           "stylers": [
//             {
//               "visibility": "on"
//             },
//             {
//               "color": "#eae9ed"
//             }
//           ]
//         },
//         {
//           "featureType": "landscape.natural",
//           "elementType": "geometry.fill",
//           "stylers": [
//             {
//               "visibility": "on"
//             },
//             {
//               "color": "#d2e0b7"
//             }
//           ]
//         },
//         {
//           "featureType": "landscape.natural.landcover",
//           "elementType": "geometry.fill",
//           "stylers": [
//             {
//               "visibility": "on"
//             },
//             {
//               "color": "#d2e0b7"
//             }
//           ]
//         },
//         {
//           "featureType": "landscape.natural.terrain",
//           "elementType": "geometry",
//           "stylers": [
//             {
//               "visibility": "on"
//             },
//             {
//               "color": "#d2e0b7"
//             }
//           ]
//         },
//         {
//           "featureType": "poi",
//           "elementType": "all",
//           "stylers": [
//             {
//               "visibility": "off"
//             }
//           ]
//         },
//         {
//           "featureType": "poi.park",
//           "elementType": "geometry.fill",
//           "stylers": [
//             {
//               "visibility": "on"
//             }
//           ]
//         },
//         {
//           "featureType": "road",
//           "elementType": "all",
//           "stylers": [
//             {
//               "saturation": -100
//             },
//             {
//               "lightness": 45
//             }
//           ]
//         },
//         {
//           "featureType": "road",
//           "elementType": "geometry.fill",
//           "stylers": [
//             {
//               "visibility": "on"
//             },
//             {
//               "color": "#ffffff"
//             }
//           ]
//         },
//         {
//           "featureType": "road",
//           "elementType": "geometry.stroke",
//           "stylers": [
//             {
//               "visibility": "off"
//             }
//           ]
//         },
//         {
//           "featureType": "road",
//           "elementType": "labels.text.stroke",
//           "stylers": [
//             {
//               "visibility": "off"
//             }
//           ]
//         },
//         {
//           "featureType": "road.highway",
//           "elementType": "all",
//           "stylers": [
//             {
//               "visibility": "simplified"
//             }
//           ]
//         },
//         {
//           "featureType": "road.arterial",
//           "elementType": "labels.icon",
//           "stylers": [
//             {
//               "visibility": "off"
//             }
//           ]
//         },
//         {
//           "featureType": "transit",
//           "elementType": "all",
//           "stylers": [
//             {
//               "visibility": "off"
//             }
//           ]
//         },
//         {
//           "featureType": "water",
//           "elementType": "all",
//           "stylers": [
//             {
//               "color": "#b3dced"
//             },
//             {
//               "visibility": "on"
//             }
//           ]
//         },
//         {
//           "featureType": "water",
//           "elementType": "labels.text.fill",
//           "stylers": [
//             {
//               "visibility": "on"
//             },
//             {
//               "color": "#ffffff"
//             }
//           ]
//         },
//         {
//           "featureType": "water",
//           "elementType": "labels.text.stroke",
//           "stylers": [
//             {
//               "visibility": "off"
//             },
//             {
//               "color": "#e6e6e6"
//             }
//           ]
//         }
//       ]
//     };
//
//     var map = new google.maps.Map( map_container, myOptions );
//     if (map_lat && map_lng) {
//       var marker = new google.maps.Marker({
//         position: { lat: parseFloat(map_lat), lng: parseFloat(map_lng) },
//         map: map,
//         icon: { url: '/themes/planetleasing/img/icons/marker.svg', scaledSize: new google.maps.Size(100, 100) }
//       });
//     }
//     if (map_lat_2 && map_lng_2) {
//       var marker2 = new google.maps.Marker({
//         position: { lat: parseFloat(map_lat_2), lng: parseFloat(map_lng_2) },
//         map: map,
//         icon: { url: '/themes/planetleasing/img/icons/marker.svg', scaledSize: new google.maps.Size(100, 100) }
//       });
//     }
//     if (map_lat_3 && map_lng_3) {
//       var marker3 = new google.maps.Marker({
//         position: { lat: parseFloat(map_lat_3), lng: parseFloat(map_lng_3) },
//         map: map,
//         icon: { url: '/themes/planetleasing/img/icons/marker.svg', scaledSize: new google.maps.Size(100, 100) }
//       });
//     }
//   }
// }

// Subscribe Form
if(document.getElementById('email-signup')){

  let button = document.querySelector('#email-signup');
  let terms = document.querySelector('.newsletter-form [name=consent]');
  if (terms && button){
    terms.onchange = function() {
      button.disabled = !this.checked;
    };
  }

  document.getElementById('email-signup').addEventListener("click", function(e) {
    e.preventDefault();

    var recaptcha_token = null;

    if(document.querySelector('input[name=g-recaptcha-response]')){
      recaptcha_token = document.querySelector('input[name=g-recaptcha-response]').value;
    } else {
      grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(token) {
        recaptcha_token = token;
      });
    }

    document.getElementById('email-signup').classList.add('preload');
    document.getElementById('email-signup').innerHTML = 'Please wait';
    document.getElementById('email-signup').disabled = true;

    let url = (typeof $base_path !== 'undefined' ? $base_path : '')+'/newsletter';
    let email = document.getElementById('newsletter-email').value;
    let name = document.getElementById('newsletter-name').value;
    let token = document.getElementsByName('_token')[0].value;

    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify({ 'name': name, 'first_name': name, 'email': email, 'mail_status': 'subscribed', '_token': token }), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }}).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      document.getElementById('email-signup').classList.remove('preload');
      document.getElementById('email-signup').innerHTML = 'Subscribe';
      document.getElementById('email-signup').disabled = false;

      if(data.status!='ok'){
        let errors = '';
        for (var i in data.errors) {
          errors += data.errors[i][0]+'\n';
        }
        if(typeof Swal !== 'undefined'){
          return Swal.fire({
            title: 'Whoops!',
            html: ('There was a problem with your sign up details\n\n'+errors).replace(/\n/gi,'<br>'),
            icon: 'error',
            confirmButtonText: 'OK',
          });
        } else {
          return alert('There was a problem with your sign up details\n\n'+errors);
        }
      }

      document.getElementsByClassName('newsletter-form')[0].reset();
      // Trigger event tracking
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Newsletter Signup'
      });

      if(typeof Swal !== 'undefined'){
        return Swal.fire({
          title: 'Thank you!',
          text: 'You\'re signed up!',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } else {
        return alert('Thank you!');
      }

    }).catch(function(err) {
      console.error('Fetch Error -', err);
      document.getElementById('email-signup').classList.remove('preload');
      document.getElementById('email-signup').innerHTML = 'Subscribe';
      document.getElementById('email-signup').disabled = false;
    });
  });
}

window.addEventListener('DOMContentLoaded', () => {

  // // Preloader
  // document.querySelector('html').classList.add("site-loaded");
  // document.body.classList.add("loaded");
  // setTimeout(() => { document.querySelector('.loader-ctr').remove() }, 500)
  // // END Preloader

  // Load Search Form
  function loadSearchForm () {
    // Load Search searchType
    if(document.getElementsByClassName('search-form').length>0){
      let $type = document.getElementById('search-type').getAttribute('value').toLowerCase();
      if(typeof love_electric_view == "undefined") {
        loadManufacturers($type);
      }
      // Search
      if(document.querySelectorAll('.search-form [name=make] option').length<=1 && document.getElementById('search-type')){
        $type = document.getElementById('search-type').getAttribute('value').toLowerCase();
        loadManufacturers($type);
        loadBodyTypes($type, false);
        if(document.querySelectorAll('.search-form [name=spec_level] option').length<=1 && document.querySelector('.search-form [name=model]')){
          loadSpecs($type, document.querySelector('.search-form [name=model]').value);
        }
      }
      if(document.querySelectorAll('.search-form [name=model] option').length<=1 && document.querySelector('.search-form [name=make]')){
        loadModels($type, document.querySelector('.search-form [name=make]').value);
      }
      if(document.querySelectorAll('.search-form [name=spec_level] option').length<=1 && document.querySelector('.search-form [name=model]')){
        loadSpecs($type, document.querySelector('.search-form [name=model]').value);
      }

      if (document.querySelector('.search-form [name=make]')) {
        document.querySelector('.search-form [name=make]').addEventListener("change", function(e){
          $type = document.getElementById('search-type').getAttribute('value').toLowerCase();
          if (document.querySelector('.search-form [name=model]')) {
            (e.target.value) ? document.querySelector('.search-form [name=model]').parentElement.classList.remove('visuallyhidden') : document.querySelector('.search-form [name=model]').parentElement.classList.add('visuallyhidden');
          }
          (document.querySelector('.search-form [name=spec_level]')) ? document.querySelector('.search-form [name=spec_level]').parentElement.classList.add('visuallyhidden') : null;
          loadModels($type, e.target.value);
          loadSpecs($type);
        });
      }
      if (document.querySelector('.search-form [name=model]')) {
        document.querySelector('.search-form [name=model]').addEventListener("change", function(e){
          $type = document.getElementById('search-type').getAttribute('value').toLowerCase();
          if (document.querySelector('.search-form [name=spec_level]')) {
            (e.target.value) ? document.querySelector('.search-form [name=spec_level]').parentElement.classList.remove('visuallyhidden') : document.querySelector('.search-form [name=spec_level]').parentElement.classList.add('visuallyhidden');
          }
          loadSpecs($type, e.target.value);
        });
      }
    }
  }
  loadSearchForm();
  loadUrlParams();
  // END Load Search Form

  // Search Sidebar Toggle
  let sidebarToggle = document.querySelectorAll('#search-filters-toggle');
  let sidebar = document.querySelector('.search-aside');
  if (sidebarToggle && sidebar) {
    sidebarToggle.forEach(value => {
      value.addEventListener('click', (e) => {
        if (!sidebar.classList.contains('active')) {
          // setTimeout(() => {
          //   sidebar.scrollIntoView();
          // }, 500);
          document.querySelector('.search-content').style.minHeight = `${(document.querySelector('.search-results-form').clientHeight) * 2}px`;
        } else {
          e.preventDefault();
          document.querySelector('.search-content').style.minHeight = `100px`;
        }
        sidebar.classList.toggle('active');
        // sidebarToggle.blur();
        sidebar.focus();
      })
    })
  }
  // END Search Sidebar Toggle

  // Show Only Filters
  let searchToggles = document.querySelectorAll('.search-filters input');
  if (searchToggles) {
    searchToggles.forEach(value => {
      value.addEventListener('change', (e) => {
        let searchUrl = new URL(window.location.origin + '/car-leasing');
        let vans = (window.location.pathname.includes('van-leasing') || window.location.search.includes('search-type=van')) ? '/van-leasing' : '';
        (window.location.pathname.includes('van-leasing')) ? searchUrl = new URL(window.location.origin + '/van-leasing') : null;
        if(e.target.checked) {
          (e.target.value === 'special') ? searchUrl = new URL(window.location.origin + vans + '/special-offers') : null;
          (e.target.value === 'stock') ? searchUrl = new URL(window.location.origin + vans + '/stock') : null;
          (e.target.value === 'special' && e.target.dataset.module === 'Electric.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=specials&fuel_type=Electric') : null;
          (e.target.value === 'stock' && e.target.dataset.module === 'Electric.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=stock&fuel_type=Electric') : null;
          (e.target.value === 'special' && e.target.dataset.module === 'Hybrid.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=specials&fuel_type=Hybrid') : null;
          (e.target.value === 'stock' && e.target.dataset.module === 'Hybrid.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=stock&fuel_type=Hybrid') : null;
          (e.target.value === 'special' && window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=stock', 'offers=specials')) : null;
          // (e.target.value === 'stock' && window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=specials', 'offers=stock')) : null;
          // (e.target.value === 'special' && window.location.pathname==="/search" && !window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('&search-type=', '&offers=specials&search-type=')) : null;
          (e.target.value === 'special' && window.location.pathname==="/search" && !window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search ? window.location.search += '&offers=specials' : window.location.search += '?offers=specials') : null;
          // (e.target.value === 'stock' && window.location.pathname==="/search" && !window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('&search-type=', '&offers=stock&search-type=')) : null;
          (e.target.value === 'stock' && window.location.pathname==="/search" && !window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search ? window.location.search += '&offers=stock' : window.location.search += '?offers=stock') : null;
          (e.target.value === 'special' && window.location.search.includes('offers=&')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=&', 'offers=specials&')) : null;
          (e.target.value === 'stock' && window.location.search.includes('offers=&')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=&', 'offers=stock&')) : null;
        } else if(!e.target.checked) {
          (e.target.value === 'special' && window.location.search.includes('offers=specials')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=specials', 'offers=')) : null;
          (e.target.value === 'stock' && window.location.search.includes('offers=stock')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=stock', 'offers=')) : null;
          (e.target.value === 'special' && e.target.dataset.module === 'Stock.Offers') ? searchUrl = new URL(window.location.origin + vans + '/stock') : null;
          (e.target.value === 'stock' && e.target.dataset.module === 'Stock.Offers' && document.querySelector('.search-filters input[name="special"]:checked')) ? searchUrl = new URL(window.location.origin + vans + '/special-offers') : null;
        }

        document.body.classList.remove('loaded');
        window.location.href = searchUrl;
      })
    })
  }
  // END Show Only Filters

  // Reset Search
  let resetButton = document.querySelector('.search-buttons .button-reset');
  if (resetButton) {
    resetButton.addEventListener('click', e => {
      let searchUrl = new URL(window.location.origin + window.location.pathname);
      document.body.classList.remove('loaded');
      window.location.href = searchUrl;
    })
  }
  // END Reset Search

  // Deal View Toggler
  let listView = document.querySelector('.deal-view-toggler #view_list');
  let gridView = document.querySelector('.deal-view-toggler #view_grid');
  let dealList = document.querySelector('.deal-list');
  if (listView && gridView && dealList) {
    listView.addEventListener('click', (evt) => {
      evt.target.classList.add('active');
      gridView.classList.remove('active');
      dealList.classList.toggle('deal-list-list');
      writeCookie('deal_list_view', 'list');
    });
    gridView.addEventListener('click', (evt) => {
      evt.target.classList.add('active');
      listView.classList.remove('active');
      dealList.classList.toggle('deal-list-list');
      writeCookie('deal_list_view', 'grid');
    })
  }
  // END Deal View Toggler

});

setTimeout(function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // setTimeout(() => { document.querySelector('.loader-ctr').remove() }, 500)
  // END Preloader
}, 2000);


document.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // setTimeout(() => { document.querySelector('.loader-ctr').remove() }, 500)
  // END Preloader
});

window.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // setTimeout(() => { document.querySelector('.loader-ctr').remove() }, 500)
  // END Preloader
});

window.addEventListener('DOMContentLoaded', () => {
  if(document.getElementsByClassName('optional-information').length>0 && document.getElementsByClassName('search-form').length>0){
    let $type = document.getElementById('search-type').getAttribute('value').toLowerCase();
    loadManufacturers($type);

    // Search
    if(document.querySelectorAll('.search-form [name=make] option').length<=1 && document.getElementById('search-type')){
      $type = document.getElementById('search-type').getAttribute('value').toLowerCase();
      loadManufacturers($type);
    }
    if(document.querySelectorAll('.search-form [name=model] option').length<=1 && document.querySelector('.search-form [name=make]')){
      loadModels($type, document.querySelector('.search-form [name=make]').value);
    }

    if (document.querySelector('.search-form [name=make]')) {
      document.querySelector('.search-form [name=make]').addEventListener("change", function(e){
        $type = document.getElementById('search-type').getAttribute('value').toLowerCase();
        if (document.querySelector('.search-form [name=model]')) {
          (e.target.value) ? document.querySelector('.search-form [name=model]').parentElement.classList.remove('visuallyhidden') : document.querySelector('.search-form [name=model]').parentElement.classList.add('visuallyhidden');
        }
        loadModels($type, e.target.value);
      });
    }
  }
});
